import React from 'react';
import { Player } from 'video-react';
import classNames from 'classnames';

import './GetAppInfoPlayer.scss';

const GetAppInfoVideoPlayer = ({ videoRef, isPlaying }) => {
  const videoUrl = 'https://everdays-resources.s3.amazonaws.com/videos/onboard/appOnboard.mp4';
  const videoPlayerClass = classNames('video-media', { 'not-playing': !isPlaying });

  return (
    <div className={videoPlayerClass}>
      <Player ref={videoRef} src={videoUrl} autoPlay={false} aspectRatio="9:16" />
    </div>
  );
};

export default GetAppInfoVideoPlayer;
